<template>
    <div>
        <page-title-bar></page-title-bar>
        <v-container v-if="loader" fluid grid-list-xl pt-0>
            <v-layout row wrap>
                <v-flex xs12 md12 lg12 sm12 class="col-height-auto">
                    <template>
                        <!--<diamond></diamond>-->
                        <!--<rotate-square2></rotate-square2>-->
                        <circle2></circle2>
                    </template>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container v-if="!loader" fluid grid-list-xl pt-0>
            <v-layout row wrap>
                <v-flex xs12 md12 lg12 sm12 class="col-height-auto">
                    <div>
                        <app-card customClasses="mb-3 elevation-5">
                            <div class="user-image text-xs-center mb-3">
                                <img :src="customerPicture" class="img-responsive " alt="user images" width="250" />
                            </div>
                            <div class="text-xs-center mb-3">
                                <h2 class="fw-bold">{{abbonato.customer.name}}</h2>
                                <p>{{abbonato.customer.birthDate}}</p>
                            </div>
                            <v-card-actions class="justify-center">
                                <v-btn center color="primary" large to="/abbonati/ricerca">NUOVA RICERCA</v-btn>
                            </v-card-actions>
                        </app-card>
                        <!--<app-card customClasses="mb-3 elevation-5" v-if="abbonato.cards.length > 0">
                            <div class="text-xs-center">
                                <h2 class="fw-bold">STATO ABBONAMENTI</h2>
                            </div>
                        </app-card>-->
                        <v-card v-for="item in abbonato.cards" class="mx-auto mb-2 elevation-5" v-if="abbonato.cards.length > 0">
                            <v-toolbar :color="item.color" dark>
                                <v-icon large left class="mr-3">{{item.icon}}</v-icon>
                                <v-toolbar-title two-lines>
                                    <div class="ma-0 pa-0" style="line-height:20px">{{item.serial}}</div>
                                    <div class="caption ma-0 pa-0">{{item.nameAndType}}</div>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text class="green lighten-4">
                                <p class="mb-2 text-center caption"><span class="font-weight-medium">Acquisto/Scadenza:</span> {{item.saleDate}} - {{item.expireAt}}</p>
                                <!--<p class="body-2 mb-2 text-center">CONTRATTI</p>-->
                                <v-list class="green lighten-5" three-line>
                                    <v-divider></v-divider>
                                    <v-list-tile v-for="c in item.contracts" @click="">
                                        <v-list-tile-content>
                                            <v-list-tile-title class="font-weight-bold" v-html="c.contractName"></v-list-tile-title>
                                            <v-list-tile-sub-title>DAL:     {{ c.validityStart }}</v-list-tile-sub-title>
                                            <v-list-tile-sub-title>AL:      {{ c.validityEnd }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-divider></v-divider>
                                </v-list>
                            </v-card-text>
                        </v-card>
                        <div class="text-xs-center">
                            <v-btn center color="primary" large to="/abbonati/ricerca">NUOVA RICERCA</v-btn>
                        </div>

                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>


<script>
    import api from "Api";
    import moment from "moment";
    import AppConfig from "Constants/AppConfig";



    export default {
        components: {
        },
        data() {
            return {
                loader: true,
                abbonato: {
                    customer: {},
                    picture: "",
                    cards: []
                }
            };
        },
        mounted() {
            this.fetchAbbonato(this.$route.params.id);
        },
        computed: {
            customerPicture() {
                return "data:image/jpeg;base64," + this.abbonato.picture;
            }
        },
        methods: {
            fetchAbbonato(id) {
                var instance = this;
                instance.loader = true;
                var url = "controlloabbonamenti/customer/" + id;

                api.instance
                    .get(url)
                    .then(response => {
                        instance.loader = false;
                        instance.abbonato = response.data;

                    })
                    .catch(error => {
                        instance.loader = false;
                        Vue.notify({
                            type: 'warning',
                            text: 'Si � verificato un errore durante la richiesta. Riprovare o contattare l\'assistenza',
                            duration: 3000
                        });
                    });
                //this.items = [
                //    {
                //        type: "Ordinario giornaliero",
                //        serial: "2545AD966",
                //        expireAt: "25/01/2119",
                //        icon: "check_circle",
                //        iconColor: "green darken-2"
                //    },
                //    {
                //        type: "Ordinario weekend",
                //        serial: "2545AD978",
                //        expireAt: "25/01/2018",
                //        icon: "highlight_off",
                //        iconColor: "red darken-2"
                //    }
                //];

            }
        }
    };
</script>

<!--<script>
    import Vue from "vue";
    import api from "Api";
    import moment from "moment";

    export default {
        data() {
            return {
                loader: true,
                nodata: false,
                errorMessage: "",
                firstAccess: true,
                items: [],
                searchModel: {
                    lastName: "",
                    birthDateDay: "",
                    birthDateMonth: "",
                    birthDateYear: ""
                }
            };
        },
        mounted() {
            //this.getTablesData();
        },
        computed: {

        },
        methods: {
            search() {

                var instance = this;

                var request = {
                    lastName: this.searchModel.lastName,
                    birthDate: this.searchModel.birthDateYear + "-" + this.searchModel.birthDateMonth + "-" + this.searchModel.birthDateDay
                };

                api.instance
                    .post("controlloabbonamenti/search", request)
                    .then(response => {
                        instance.loader = false;
                        instance.firstAccess = false;

                        if (response.data.status == "ok") {
                            if (response.data.isSingle) {
                                instance.$router.push({ name: 'abbonato', params: { id: response.data.customers[0].id } });
                            }
                            else {
                                instance.items = response.data.customers;
                                this.nodata = response.data.customers.length = 0;
                            }
                        }
                        else {
                            instance.errorMessage = response.data.message;
                        }
                    })
                    .catch(error => {
                        Vue.notify({
                            type: 'warning',
                            text: 'Si � verificato un errore durante la richiesta. Riprovare o contattare l\'assistenza',
                            duration: 3000
                        });
                    });
            }
        }
    };</script>-->
